import { OptionComponent } from './Option'
import { Span } from 'components/styles'
import { Callback } from 'types/index'
import { Option } from '../../../components/inputs/elements/types'
import { FlexBox } from 'ui/primitives'

interface ButtonGroupProps<T> {
	options: Array<Option<T>>
	value: T
	onChange: Callback<T>
}

export const ButtonGroup = <T,>({ options, value, onChange }: ButtonGroupProps<T>) => {
	return (
		<FlexBox justifyContent="flex-start">
			{options.map(option => (
				<OptionComponent key={option.label} selected={value === option.value} onClick={() => onChange(option.value)}>
					{option.label}
					{option.hint && (
						<Span small light>
							{option.hint}
						</Span>
					)}
				</OptionComponent>
			))}
		</FlexBox>
	)
}
